import { useQuery } from "@apollo/client";
import { GET_NEED_SETUP_MODULE_SETTINGS } from "@/modules/global-wizard/features/setup-module-settings/api/get-need-setup-module-settings";

export function useCheckNeedSetupModuleSettings() {
  const { data, loading, refetch } = useQuery(GET_NEED_SETUP_MODULE_SETTINGS);

  return {
    isNeedSetup: data?.getNeedSetupModuleSettings,
    loading,
    refetch,
  };
}
